"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-6">
      <div className="flex items-center gap-3 text-destructive">
        <AlertTriangle className="h-8 w-8" aria-hidden="true" />
        <h1 className="text-2xl font-mono font-semibold">Something went wrong</h1>
      </div>
      <p className="text-muted-foreground text-center max-w-md">
        An unexpected error occurred. Please try again or return to a safe page.
      </p>
      {error.digest && (
        <p className="text-xs text-muted-foreground font-mono">
          Error ID: {error.digest}
        </p>
      )}
      <div className="flex flex-wrap gap-3 justify-center">
        <Button onClick={reset}>
          Try again
        </Button>
        <Button asChild variant="outline">
          <Link href="/">Return home</Link>
        </Button>
        <Button asChild variant="outline">
          <Link href="/projects">Projects</Link>
        </Button>
        <Button asChild variant="outline">
          <Link href="/contact">Contact</Link>
        </Button>
      </div>
    </div>
  );
}
